import { StorageKeysEnum } from '@/common/enums/storageKeysEnum'
import router from '@/router'
import StripeService from '@/services/stripeService'
import { useUserStore } from '@/stores/user'
import { usePlansStore } from '@/stores/plans'

export const backToWlDashboard = async () => {
  const userStore = useUserStore()
  const plansStore = usePlansStore()
  localStorage.removeItem('customer-uuid')
  localStorage.removeItem(StorageKeysEnum.WL_OWNER_VISITING_CUSTOMER)
  userStore.wlVisitingCustomer = false
  await userStore.backToAdmin()
  let tab = 'overview'
  if (router.currentRoute.value.name === 'sites-site_id') {
    tab = 'sites'
  }
  userStore.wlDetails =
    userStore.userProfile && userStore.userProfile.wlDetails
      ? userStore.userProfile.wlDetails
      : null
  const plans = await StripeService.getPlans()
  userStore.wlPlatformOfCustomer = userStore.userProfile?.wlPlatformOfCustomer
  plansStore.plans = plans as any
  await router
    .replace({
      name: 'white-label',
      query: { tab },
    })
    .then(() => {
      router.go(0)
    })
}
